// src/components/KitchenCleaning.jsx
import ServicePage from "../Common/ServicePage";

const packages = [
  { id: 1, title: "Basic Kitchen Cleaning", rating: "4.80 (2.3k reviews)", price: 600, originalPrice: 750, icon: "restaurant" },
  { id: 2, title: "Deep Kitchen Cleaning", rating: "4.85 (1.8k reviews)", price: 1200, originalPrice: 1400, icon: "kitchen" },
  { id: 3, title: "Full Modular Kitchen Cleaning", rating: "4.90 (1.2k reviews)", price: 1800, originalPrice: 2000, icon: "countertops" },
];

const miniServices = [
  { id: 101, title: "Chimney Cleaning", price: 300, icon: "smoke_free" },
  { id: 102, title: "Fridge Inside Cleaning", price: 350, icon: "ac_unit" },
  { id: 103, title: "Microwave Cleaning", price: 200, icon: "microwave" },
  { id: 104, title: "Gas Stove Cleaning", price: 150, icon: "local_fire_department" },
];

export default function KitchenCleaning() {
  return (
    <ServicePage
      serviceName="Kitchen Cleaning"
      packages={packages}
      miniServices={miniServices}
    />
  );
}
